import React from 'react';
import { DjayIllustrationProps } from '../types';
import { DjayIllustrationBase } from '../DjayIllustrationBase';
import { DjaySpecimen } from '../../DjaySpecimen';
export function Level7Illustration({
  variant = 'default',
  isUnlocked,
  rarity,
  size = 'md',
  animate = true,
  className = ''
}: DjayIllustrationProps) {
  return <DjayIllustrationBase isUnlocked={isUnlocked} rarity={rarity} size={size} className={className} data-id="element-4137" data-mp="3g6ax4e9a5e3n">
      
      <div className="relative w-full h-full bg-gradient-to-b from-emerald-200 to-teal-400 overflow-hidden" data-id="element-4138" data-mp="hmb1q76qh4fz">
        {/* Background: Big tree */}
        <svg className="absolute inset-0 w-full h-full z-0" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-4139" data-mp="7wri2zb756k2">
          
          <path d="M0 170 L200 170 L200 200 L0 200 Z" fill="#15803D" opacity="0.5" data-id="element-4140" data-mp="2xoms6l0qepa" />
          
          {/* Trunk */}
          <rect x="150" y="90" width="10" height="80" rx="3" fill="#92400E" data-id="element-4141" data-mp="10forlxvlakoq" />
          {/* Canopy */}
          <circle cx="155" cy="80" r="34" fill="#22C55E" data-id="element-4142" data-mp="vksp23sq8exd" />
          <circle cx="135" cy="92" r="24" fill="#16A34A" data-id="element-4143" data-mp="nidzf1ymlqkh" />
          <circle cx="176" cy="92" r="22" fill="#16A34A" data-id="element-4144" data-mp="riwnckxeeche" />
        </svg>

        {/* Djay */}
        <div className="absolute inset-0 z-10 flex items-end justify-start pb-[8%] pl-[8%]" data-id="element-4145" data-mp="drj7bgyp7wr4">
          <div className="w-[56%] h-[56%] flex items-center justify-center" data-id="element-4146" data-mp="dpovcs5enez6">
            <DjaySpecimen look={{
            variant
          }} size="hero" emotion={isUnlocked ? 'proud' : 'thinking'} animate={animate && isUnlocked} className="w-full h-full" data-id="element-4147" data-mp="iorpvinre2sw" />
            
          </div>
        </div>

        {/* Foreground: level badge */}
        {isUnlocked && <svg className="absolute inset-0 w-full h-full z-20 pointer-events-none" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-4148" data-mp="3qzcsu2nyirbm">
          
            <circle cx="40" cy="40" r="18" fill="#0F766E" data-id="element-4149" data-mp="1p658gethljiv" />
            <text x="40" y="46" textAnchor="middle" fontFamily="sans-serif" fontSize="16" fontWeight="900" fill="white" data-id="element-4150" data-mp="1p4ln49sz4ia8">
            
              7
            </text>
          </svg>}
      </div>
    </DjayIllustrationBase>;
}